import React from 'react'

function UserReport() {
  return (
    <div>UserReport</div>
  )
}

export default UserReport